/**
 * Created by Ondra on 20.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {fetchOffers} from '../../../common/offers/actions';
import {showPopupInMenu} from '../../../common/menu/actions';

class ChangeOffer extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        showPopupInMenu: React.PropTypes.func,
        fetchOffers: React.PropTypes.func,
        bar: React.PropTypes.object,
        offerName: React.PropTypes.string
    };

    constructor(props) {
        super(props);

        this.changeOffer = this.changeOffer.bind(this);
    }

    changeOffer() {
        const {bar, fetchOffers, showPopupInMenu} = this.props;
        fetchOffers(bar.get('id'));
        showPopupInMenu(true);
    }

    render() {
        const {offerName, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-left text-black">
                    <div className="boxBtn-inner text-left">
                      <div className="settings-name">
                        <span>{msg.settings.offer.title}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '22.22%'}}>
                  <div className="boxBtn text-black text-l">
                    <div className="boxBtn-inner">
                      <span>{offerName}</span>
                    </div>
                  </div>
              </div>
              <div className="table-cell" style={{width: '22.22%'}}>
                  <div className="boxBtn color-green text-l">
                    <div className="boxBtn-inner" onClick={() => this.changeOffer()}>
                      <span>{msg.settings.offer.select}</span>
                    </div>
                  </div>
              </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    offerName: state.offers.get('offerName'),
    bar: state.bars.get('bar')
}), {showPopupInMenu, fetchOffers})(ChangeOffer);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/ChangeOffer.js